module.exports = __webpack_public_path__ + "static/media/afbouwkeur-logo.0ec0678a.png";